import React, { useEffect } from 'react';
import DOMPurify from 'dompurify';
import { Card, CardContent, Typography } from '@mui/material';


interface BlogCardProps {
  data: {
    title: string;
    subtitle: string;
    content: string;
  };
}

export default function BlogCard({ data }: BlogCardProps) {
  // if (!data.content) {
  //   return null; // or some fallback UI
  // }

  const sanitizedContent = DOMPurify.sanitize(data.content, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'p', 'br', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'style', 'class']
  });

  useEffect(() => {
    // Apply basic styles for lists
    const style = document.createElement('style');
    style.innerHTML = `
      .blog-content ul, .blog-content ol {
        padding-left: 20px;
      }
      .blog-content ul {
        list-style-type: disc;
      }
      .blog-content ol {
        list-style-type: decimal;
      }
      .blog-content li {
        margin-bottom: 5px;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography variant="h5" component="div">
          {data.title}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {data.subtitle}
        </Typography>
        <div className="blog-content" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
      </CardContent>
    </Card>
  );
}